import {permissionObj} from "../../../Helpers/permission";
import CustomExpandableTable from "../../../components/table/CustomExpandableTable";
import NotInformation from "../../../components/NotInformation";
import routes from "../../../Routes/routes";
import React from "react";
import RenderExpandedRow from "./SubComponents/RenderExpandedRow";
import CustomButtonLink from "../../../components/buttons/CustomButtonLink";
import {TransportRequestTableApp} from "./Funtionality/TransportRequestTableApp";
import SearchSimple from "../../../components/SearchSimples/SearchSimple";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const TransportRequestTable = ({
    option,
    modified,
    setModified,
    setBodyForExport,
    setCriteria,
    selectedList,
    setSelectedList,
    searchElement,
    setSearchElement,
    setIsAllChecked,
    setSearch,
    simpleSearch,
    setSimpleSearch,
    setShowAcceptRequest,
    setRow,
    setShowDeclineRequest,
    setShowAssignEmployeesAndVehicles,
    setShowPreDepartureComment,
    setShowInTransitIssueComment,
    setShowIssueComment,
    setShowDetails,
    setShowDepartureComment,
    setShowArrivalComment,
    setShowDeleteModal
}) => {
    const{
        DEV,
        permission,
        searchId,
        rowsPerPage,
        searchResults,
        setSearchResults,
        handleCheckboxChange,
        pagination,
        handleDeleteAll,
        renderOptionsMenu,
        showOptions,
        handleRowExpand,
        columns,
        t,
        rowsWithDisabled
    } = TransportRequestTableApp({
        option,
        modified,
        setModified,
        setBodyForExport,
        setCriteria,
        selectedList,
        setSelectedList,
        searchElement,
        setIsAllChecked,
        setShowAcceptRequest,
        setRow,
        setShowDeclineRequest,
        setShowAssignEmployeesAndVehicles,
        setShowPreDepartureComment,
        setShowInTransitIssueComment,
        setShowIssueComment,
        setShowDetails,
        setShowDepartureComment,
        setShowArrivalComment,
        setShowDeleteModal,
    });


    return (
        <>
            <SearchSimple
                id={searchId}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={null}
                supplierId={null}
            />

            {searchResults?.content?.length > 0 ? (
                <>
                    {/**Done*/}
                    <CustomExpandableTable
                        columns={columns}
                        rows={rowsWithDisabled}
                        renderExpandedRow={RenderExpandedRow}
                        renderOptionsMenu={showOptions ? renderOptionsMenu : undefined}
                        onRowExpand={handleRowExpand}
                        selectedList={selectedList}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        rowsPerPage={rowsPerPage}
                        tooltip={true}
                        checkbox={DEV || permission?.includes(permissionObj?.WEB_LOGISTIC_REQUEST_DELETE)}
                    />
                    {pagination()}
                </>
            ) : (
                <NotInformation className={"mt-4"} card={true}>
                    <>
                        <div className="warning-text">
                            <p>{t("no_transport_request_text")}</p>
                        </div>
                        {(DEV || permission?.includes(permissionObj?.WEB_LOGISTIC_REQUEST_CREATE)) &&
                        <CustomButtonLink
                            splitName={false}
                            id="btn_tr_create"
                            card={true}
                            url={routes.transportRequest.create}
                            name="created_transport_request"
                        />
                        }
                    </>
                </NotInformation>
            )}
        </>
    )
}

export default TransportRequestTable;
